import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Collapse, List, ListItemIcon, ListItemText, MenuItem, Tooltip } from '@mui/material';
import React, { type ReactNode } from 'react';
import { useSidebarState, useTranslate } from 'react-admin';

interface Props {
  dense?: boolean;
  handleToggle: () => void;
  icon: ReactNode;
  isOpen: boolean;
  name: string;
  children: ReactNode;
}

const SubMenu = ({ handleToggle, isOpen, name, icon, children, dense = false }: Props) => {
  const translate = useTranslate();
  const [sidebarIsOpen] = useSidebarState();

  const header = (
    <MenuItem dense={dense} onClick={handleToggle}>
      <ListItemIcon sx={{ minWidth: 50 }}>{icon}</ListItemIcon>
      <ListItemText primary={translate(name)} />
      {isOpen ? <ExpandLess /> : <ExpandMore />}
    </MenuItem>
  );

  return (
    <React.Fragment>
      {/* If sidebar is open, show full header. If closed, show tooltip with header (text will be hidden by overflow usually, or we can conditionally render) */}
      {sidebarIsOpen || isOpen ? (
        header
      ) : (
        <Tooltip title={translate(name)} placement="right">
          {header}
        </Tooltip>
      )}
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List
          dense={dense}
          component="div"
          disablePadding
          sx={{
            '& .MuiMenuItem-root': {
              paddingLeft: 4,
            },
          }}
        >
          {children}
        </List>
      </Collapse>
    </React.Fragment>
  );
};

export default SubMenu;
